var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"inner-container",attrs:{"fluid":"md"}},[_c('div',[_vm._v(" This is the temporary homepage ")])])}
var staticRenderFns = []

export { render, staticRenderFns }